import * as React from "react";

const TimeoutHOC = (WrappedComponent) =>
    class Timeout extends React.PureComponent<any, any> {
        props: any;
        timeouts: any[];

        UNSAFE_componentWillMount() {
            this.timeouts = [];
        }

        setTimeout() {
            // eslint-disable-next-line prefer-spread, prefer-rest-params
            this.timeouts.push(setTimeout.apply(null, arguments));
        }

        clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }

        componentWillUnmount() {
            this.clearTimeouts();
        }

        render() {
            const { timeouts, setTimeout, clearTimeouts } = this;

            return (
                <WrappedComponent
                    timeouts={timeouts}
                    setTimeout={setTimeout}
                    clearTimeouts={clearTimeouts}
                    {...this.props}
                />
            );
        }
    };

export default TimeoutHOC;
